import axios from "axios";

const API_BASE_URL = "https://admin.dpbosssatta.co.in/api/v1/";
// const API_BASE_URL = "https://admin.superkalyan.com/api/v1/";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    deviceId: "WEB",
    deviceName: "WEB_BROWSER",
    accessStatus: 1,
  },
});

/**
 * REQUEST INTERCEPTOR
 * Automatically attach token to every request
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (config.data instanceof FormData) {
      if (config.headers.delete) {
        config.headers.delete("Content-Type");
        config.headers.delete("content-type");
      } else {
        delete config.headers["Content-Type"];
        delete config.headers["content-type"];
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * RESPONSE INTERCEPTOR
 * Handle auth errors globally
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
      const isChatUrl = error.config?.url?.includes("/chat/");

      if (error.response?.status === 401 && !isChatUrl) {
        console.warn("Auth expired — logging out");

        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");
        localStorage.removeItem("userProfile");

        window.location.href = "/login-with-mpin";
      }

    return Promise.reject(error);
  }
);

export default apiClient;
